import React, { useState, useEffect } from "react";

interface MonthYearPickerProps {
  value: Date | null;
  onChange: (value: Date) => void;
  disabled?: boolean;
}

const MonthDayYearPicker: React.FC<MonthYearPickerProps> = ({
  value,
  onChange,
  disabled,
}) => {
  const [selectedMonth, setSelectedMonth] = useState<string>("");
  const [selectedDay, setSelectedDay] = useState<string>("");
  const [selectedYear, setSelectedYear] = useState<string>("");

  useEffect(() => {
    if (value) {
      const date = new Date(value);
      setSelectedYear(date.getFullYear().toString());
      setSelectedMonth((date.getMonth() + 1).toString().padStart(2, "0"));
      setSelectedDay(date.getDate().toString().padStart(2, "0"));
    } else {
      setSelectedYear("");
      setSelectedMonth("");
      setSelectedDay("");
    }
  }, [value]);

  const handleMonthChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newMonth = e.target.value;
    setSelectedMonth(newMonth);
    if (selectedYear && selectedDay) {
      onChange(
        new Date(
          parseInt(selectedYear, 10),
          parseInt(newMonth, 10) - 1,
          parseInt(selectedDay, 10),
        ),
      );
    }
  };

  const handleDayChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newDay = e.target.value;
    setSelectedDay(newDay);
    if (selectedMonth && selectedYear) {
      onChange(
        new Date(
          parseInt(selectedYear, 10),
          parseInt(selectedMonth, 10) - 1,
          parseInt(newDay, 10),
        ),
      );
    }
  };

  const handleYearChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newYear = e.target.value;
    setSelectedYear(newYear);
    if (selectedMonth && selectedDay) {
      onChange(
        new Date(
          parseInt(newYear, 10),
          parseInt(selectedMonth, 10) - 1,
          parseInt(selectedDay, 10),
        ),
      );
    }
  };

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 100 }, (_, i) => currentYear - i);
  const months = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];
  const days = Array.from({ length: 31 }, (_, i) =>
    (i + 1).toString().padStart(2, "0"),
  );

  return (
    <div style={{ display: "flex", gap: "5px" }}>
      <select
        value={selectedMonth}
        onChange={handleMonthChange}
        className="form-select"
        style={{ width: "60%" }}
        disabled={disabled}
      >
        <option value="" disabled>
          Month
        </option>
        {months.map((month) => (
          <option key={month.value} value={month.value}>
            {month.label}
          </option>
        ))}
      </select>

      <select
        value={selectedDay}
        onChange={handleDayChange}
        className="form-select"
        style={{ width: "25%" }}
        disabled={disabled}
      >
        <option value="" disabled>
          Day
        </option>
        {days.map((day) => (
          <option key={day} value={day.toString()}>
            {day}
          </option>
        ))}
      </select>

      <select
        value={selectedYear}
        onChange={handleYearChange}
        className="form-select"
        style={{ width: "40%" }}
        disabled={disabled}
      >
        <option value="" disabled>
          Year
        </option>
        {years.map((year) => (
          <option key={year} value={year.toString()}>
            {year}
          </option>
        ))}
      </select>
    </div>
  );
};

export default MonthDayYearPicker;
